/**
 * Vuex module for video conferences.
 */
import debug from 'debug'
import API from '@/api'
import events from 'Store/events'

const dbg = debug('store:action:video-conference-config:')

const actions = {
  getConfigurations: function ({ commit }) {
    dbg('Get video conference config')
    const [start, limit, sortCol, sortDir, search] = [0, null, 'ID', 'ASC', null]
    return API.getVideoConferenceConfigs({ start, limit, sortCol, sortDir, search }).then(response => {
      const data = response.data.data
      let enabled = false
      let enableRecording = false
      let enableTelephony = false
      let enableScreenSharing = false
      let maxRoomPerRealm = -1 // unlimited
      data.forEach((videoConfiguration) => {
        if (videoConfiguration.config === 'enabled' && videoConfiguration.value === '1') {
          enabled = true
        }
        if (videoConfiguration.config === 'enable_recording' && videoConfiguration.value === '1') {
          enableRecording = true
        }
        if (videoConfiguration.config === 'enable_telephony' && videoConfiguration.value === '1') {
          enableTelephony = true
        }
        if (videoConfiguration.config === 'enable_screen_sharing' && videoConfiguration.value === '1') {
          enableScreenSharing = true
        }
        if (videoConfiguration.config === 'max_room_per_realm') {
          maxRoomPerRealm = parseInt(videoConfiguration.value)
        }
      })
      commit('ENABLED', enabled)
      commit('ENABLE_RECORDING', enableRecording)
      commit('ENABLE_TELEPHONY', enableTelephony)
      commit('ENABLE_SCREEN_SHARING', enableScreenSharing)
      commit('MAX_ROOM_PER_REALM', maxRoomPerRealm)
    }).catch(err => {
      dbg(err)
      const msg = API.getException(err) ||
                'Failed to get video conference configs from API.'
      events.pubError(msg)
    })
  }
}

const mutations = {
  ENABLED (state, enabled) {
    state.enabled = enabled
  },

  ENABLE_RECORDING (state, enableRecording) {
    state.enableRecording = enableRecording
  },

  ENABLE_TELEPHONY (state, enableTelephony) {
    state.enableTelephony = enableTelephony
  },

  ENABLE_SCREEN_SHARING (state, enableScreenSharing) {
    state.enableScreenSharing = enableScreenSharing
  },

  MAX_ROOM_PER_REALM (state, maxRoomPerRealm) {
    state.maxRoomPerRealm = maxRoomPerRealm
  }
}

const state = {
  enabled: false,
  enableRecording: false,
  enableTelephony: false,
  enableScreenSharing: false,
  maxRoomPerRealm: -1
}

const getters = {
  enabled: state => state.enabled,
  enableRecording: state => state.enableRecording,
  enableTelephony: state => state.enableTelephony,
  enableScreenSharing: state => state.enableScreenSharing,
  maxRoomPerRealm: state => state.maxRoomPerRealm
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
